export default {
  lblSignOut: 'LBL_SIGN_OUT',
  lblProfile: 'LBL_PROFILE',
  lblCreateAnother: 'LBL_CREATE_ANOTHER',
  lblDescription: 'LBL_DESCRIPTION',
  lblFirstName: 'LBL_FIRSTNAME',
  lblName: 'LBL_NAME',
  lblBlock: 'LBL_BLOCK',
  lblApartment: 'LBL_APARTMENT',
  lblCreator: 'LBL_CREATOR',
  lblCategory: 'LBL_CATEGORY',
  lblSubcategory: 'LBL_SUBCATEGORY',
  lblDeleteSelection: 'LBL_DELETE_SELECTION',
  lblPhoto: 'LBL_PHOTO',
  lblVideo: 'LBL_VIDEO',
  lblDocument: 'LBL_DOCUMENT',
  lblDisconnected: 'LBL_DISCONNECTED',
  lblState: {
    open: 'LBL_STATE_OPEN',
    in_progress: 'LBL_STATE_IN_PROGRESS',
    reopen: 'LBL_STATE_REOPEN',
    close: 'LBL_STATE_CLOSE'

  },
  lblSort: {
    'lblSortType-1': 'LBL_MORE_RECENT',
    lblSortType1: 'LBL_OLDER'
  },
  lblcondominiumRegulations: 'LBL_CONDOMINIUM_REGULATIONS',
  lblorderOfAccount: 'LBL_ORDER_OF_ACCOUNT',
  lblreportOfInterventions: 'LBL_REPORT_OF_INTERVENTIONS',
  lblpvGeneralAssembly: 'LBL_PV_GENERAL_ASSEMBLY',
  lblQuotation: 'LBL_QUOTATION',
  lblBill: 'LBL_BILL',
  lblManagementReport: 'LBL_MANAGEMENT_REPORT',
  lblcall_ForFunds: 'LBL_CALL_FOR_FUNDS',
  lblstatementOfExpenditure: 'LBL_STATEMENT_OF_EXPENDITURE',
  lblSelectorEmpty: 'LBL_SELECTOR_EMPTY',
  lblSelectorNoData: 'LBL_SELECTOR_NO_DATA',
  lblSelectorNoDataAvailable: 'LBL_SELECTOR_NO_DATA_AVAILABLE',
  lblNotification: {
    message: 'LBL_NOTIFICATION_MESSAGE',
    attachment: 'LBL_NOTIFICATION_ATTACHMENT',
    mandate_request: 'LBL_NOTIFICATION_MANDATE_REQUEST',
    quote_request: 'LBL_NOTIFICATION_QUOTE_REQUEST',
    open: 'LBL_NOTIFICATION_OPEN',
    close: 'LBL_NOTIFICATION_CLOSE',
    reopen: 'LBL_NOTIFICATION_REOPEN',
    join: 'LBL_STATE_JOIN',
    join_channel: 'LBL_STATE_JOIN_CHANNEL',
    ask_appointment: 'LBL_STATE_ASK_APPOINTMENT',
    confirm_appointment: 'LBL_STATE_CONFIRM_APPOINTMENT',
    done_appointment: 'LBL_STATE_DONE_APPOINTMENT',
    reject_appointment: 'LBL_STATE_REJECT_APPOINTMENT',
    cancel_appointment: 'LBL_STATE_CANCEL_APPOINTMENT',
    intervention_report: 'LBL_STATE_INTERVENTION_REPORT',
    update_appointment: 'LBL_STATE_UPDATE_APPOINTMENT',
    new_group: 'LBL_STATE_NEW_GROUP',
    quit_channel: 'LBL_STATE_QUIT_CHANNEL',
    remove_ic: 'LBL_STATE_REMOVE_IC',
    close_channel: 'LBL_STATE_CLOSE_CHANNEL',
    reopen_channel: 'LBL_STATE_REOPEN_CHANNEL',
    update_ticket: 'LBL_NOTIFICATION_UPDATE_TICKET'

  },
  lblTicket: {
    message: 'LBL_NOTIFICATION_MESSAGE',
    attachment: 'LBL_NOTIFICATION_ATTACHMENT',
    mandate_request: 'LBL_NOTIFICATION_MANDATE_REQUEST',
    quote_request: 'LBL_NOTIFICATION_QUOTE_REQUEST',
    open: 'LBL_NOTIFICATION_OPEN',
    close: 'LBL_NOTIFICATION_CLOSE',
    reopen: 'LBL_NOTIFICATION_REOPEN',
    join: 'LBL_STATE_JOIN',
    join_channel: 'LBL_STATE_JOIN_CHANNEL',
    ask_appointment: 'LBL_STATE_ASK_APPOINTMENT',
    confirm_appointment: 'LBL_STATE_CONFIRM_APPOINTMENT',
    done_appointment: 'LBL_STATE_DONE_APPOINTMENT',
    reject_appointment: 'LBL_STATE_REJECT_APPOINTMENT',
    cancel_appointment: 'LBL_STATE_CANCEL_APPOINTMENT',
    intervention_report: 'LBL_STATE_INTERVENTION_REPORT',
    update_appointment: 'LBL_STATE_UPDATE_APPOINTMENT',
    new_group: 'LBL_STATE_NEW_GROUP_TICKET',
    quit_channel: 'LBL_STATE_QUIT_CHANNEL',
    remove_ic: 'LBL_STATE_REMOVE_IC',
    close_channel: 'LBL_STATE_CLOSE_CHANNEL',
    reopen_channel: 'LBL_STATE_REOPEN_CHANNEL',
    update_ticket: 'LBL_NOTIFICATION_UPDATE_TICKET'

  },
  lblNotificationEmpty: 'LBL_NOTIFICATION_EMPTY',
  lblHTML5Required: 'LBL_HTML5_REQUIRED',
  lblUploading: 'LBL_UPLOADING',
  lblConfirm: 'LBL_CONFIRM',
  lblSortBy: 'LBL_SORTBY',
  lblAll: 'LBL_ALL',
  lblAllWithoutType: 'LBL_ALL_WITHOUT_TYPE',
  lblList: 'LBL_LIST',
  lblGrid: 'LBL_GRID',
  lblNoRecords: 'LBL_NO_RECORDS_FOUND',
  lblErrorHappen: 'LBL_ERROR_HAPPEN',
  lblContactDetails: 'LBL_CONTACT_DETAILS',
  lblPassword: 'LBL_PASSWORD',
  lblCellphone: 'LBL_CELLPHONE',
  lblLandline: 'LBL_LANDLINE',
  disabled: 'LBL_DISABLED',
  enabled: 'LBL_ENABLED',
  otherItems: 'LBL_OTHER_ITEMS',
  createdAt: 'LBL_LIST_CREATEDAT',
  createdBy: 'LBL_LIST_CREATEDBY',
  updatedAt: 'LBL_LIST_UPDATEDAT',
  updatedBy: 'LBL_LIST_UPDATEDBY',
  unreadNotification: 'LBL_UNREAD_NOTIFICATION',
  markAsRead: 'LBL_MARK_AS_READ',
  displayAll: 'LBL_DISPLAY_ALL',
  deleteAll: 'LBL_DELETE_ALL',
  emptyNotification: 'LBL_EMPTY_NOTIFICATION',
  emptyNotificationDescription: 'LBL_EMPTY_NOTIFICATION_DESCRIPTION',
  basicSearch: 'BASIC_SEARCH',
  advancedSearch: 'ADVANCED_SEARCH',
  generateReport: 'GENERATE_REPORT',
  buttonNewItems: 'NOTIFICATION_NEW_ITEMS',
  shareByEmail: 'SHARE_BY_EMAIL',
  addEmail: 'ADD_EMAIL',
  invalidEmail: 'INVALID_EMAIL',
  lblMessageCode: 'LBL_MESSAGE_CODE',
  lblAppVersion: 'LBL_APP_VERSION',
  lblDragAndDrop: 'LBL_DRAG_AND_DROP',
  lblFilterPlaceholder: 'LBL_FILTER_PLACEHOLDER',
  lblNoDocs: 'LBL_NO_DOCS',
  lblTicketName: 'LBL_TICKET_NAME',
  lblArchived: 'LBL_ARCHIVED',
  lblTimeFromTo: 'LBL_TIME_FROM_TO',
  lblDelete: 'LBL_DELETE',
  lblValue: 'LBL_VALUE',
  lblOwner: 'LBL_OWNER',
  lblTenant:'LBL_TENANT',
  startDate:'START_DATE',
  endDate:'END_DATE',
  generate:'GENERATE',
}



// WEBPACK FOOTER //
// ./src/locales/generic-labels/index.ts